import React, { FC } from "react";
import { observer } from "mobx-react-lite";

interface BannerItemProps {
 title: string;
 id: string;
 priority: string;
 isActive: boolean;
 description: string;
 seoName: string;
 post: string;
 link: string;
 mainImg?: string;
 setCopied: (e: boolean) => void;
 openModalEdit: (id: string) => void;
 actionShowPopupConfirm: (e: boolean) => void;
 setActiveEditListID: (id: string) => void;
}

const PostItem: FC<BannerItemProps> = (props) => {
 const handleCopy = (textToCopy: string) => {
  navigator.clipboard
   .writeText(textToCopy)
   .then(() => {
    props.setCopied(true);
    setTimeout(() => props.setCopied(false), 1500);
   })
   .catch((err) => {
    console.error("Error while copying:", err);
   });
 };

 return (
  <>
   <tr>
    <td className="dashboard-list-item_main">
     <span
      className="dashboard-list-item_main_item"
      onClick={() => handleCopy(props.id)}
     >
      {props.id}
      <i className={`bx bx-copy`}></i>
     </span>
     <hr />
     <span
      className="dashboard-list-item_main_item"
      onClick={() => handleCopy(props.seoName)}
     >
      {props.seoName}
      <i className={`bx bx-copy`}></i>
     </span>
    </td>
    <td className="banner_item_img_box">
     <img
      className="banner_item_img_box-img"
      src={props.mainImg}
      alt={props.mainImg}
     />
    </td>
    <td className="dashboard-list-item_title">{props.title}</td>
    <td ><span className="badge badge-secondary bg-secondary badge-pill p-auto align-content-center justify-content-center" style={{
     width: '24px',
     height: '24px',
     borderRadius: '50%',
     lineHeight: '1'}}>{props.priority}</span></td>
    <td>
     <button
      onClick={() => {
       props.openModalEdit(props.id);
      }}
      className="btn btn-secondary"
     >
      edit
     </button>
    </td>
    <td>
     <button
      className="btn btn-danger"
      onClick={() => {
       props.setActiveEditListID(props.id);
       props.actionShowPopupConfirm(true);
       document.body.style.overflow = "hidden";
      }}
     >
      Delete
     </button>
    </td>
   </tr>
  </>
 );
};

export default observer(PostItem);
